<template>
    <div>
        <!-- Overlay bloqueante solo mientras no aceptó términos -->
        <div v-if="visible && showTerms && !termsAccepted" class="terms-overlay-blocker"></div>

        <div v-if="visible" ref="wrap" class="rollover-wrap" :style="wrapStyle">
            <!-- PANEL -->
            <transition name="tracker-pop">
                <div v-if="open" ref="panel" class="rollover-panel" :class="panelPlacementClass">
                    <!-- VISTA TÉRMINOS -->
                    <template v-if="showTerms">
                        <div class="panel-header">
                            <div>
                                <div class="panel-eyebrow">PROMOCIÓN ACTIVA</div>
                                <div class="panel-title">Términos y condiciones</div>
                            </div>

                            <button v-if="termsAccepted" class="panel-close" @click="open = false" type="button">
                                ✕
                            </button>
                        </div>

                        <!-- cabecera compacta -->
                        <div class="terms-compact-hero">
                            <div class="terms-compact-left">
                                <div class="terms-mini-badge">BONO DE BIENVENIDA</div>
                                <div class="terms-mini-title">
                                    <span class="money-symbol money-symbol--hero">{{ moneda }}</span>
                                    <span>{{ numberOnly(montoBono) }}</span>
                                    <span class="terms-mini-title__extra"> + 10 Free Spins</span>
                                </div>
                            </div>

                            <div class="terms-mini-chip">{{ rollover }}x rollover</div>
                        </div>

                        <!-- RESUMEN o TÉRMINOS COMPLETOS -->
                        <div v-if="!showFullTerms" class="terms-summary-card">
                            <div class="terms-summary-title">Resumen importante</div>

                            <div class="terms-summary-list">
                                <div class="terms-summary-item">
                                    La promo aplica para <strong>clientes que realicen su primer depósito</strong>.
                                </div>

                                <div class="terms-summary-item">
                                    El depósito mínimo para participar es de <strong>5 unidades</strong>.
                                </div>

                                <div class="terms-summary-item">
                                    Debes jugar los <strong>10 Free Spins completos</strong> para generar el
                                    <strong>BONO CASINO</strong>.
                                </div>

                                <div class="terms-summary-item">
                                    El bono no se libera de inmediato: debes cumplir un
                                    <strong>rollover de {{ rollover }}x</strong>.
                                </div>

                                <div class="terms-summary-item">
                                    El rollover se completa apostando con <strong>dinero real</strong>.
                                </div>

                                <div class="terms-summary-item">
                                    Solo cuentan apuestas en <strong>slots</strong>.
                                </div>

                                <div class="terms-summary-item">
                                    El rollover debe completarse <strong>el mismo día</strong>.
                                </div>

                                <div class="terms-summary-item">
                                    El bono tiene un máximo de <strong>20 unidades</strong>.
                                </div>
                            </div>
                            <button class="terms-toggle-btn" type="button" @click="showFullTerms = true">
                                Ver términos completos
                            </button>
                        </div>

                        <div v-else class="terms-full-card">
                            <div class="terms-full-head">
                                <div class="terms-summary-title">Términos completos</div>

                                <button class="terms-toggle-btn terms-toggle-btn--back" type="button"
                                    @click="showFullTerms = false">
                                    Volver al resumen
                                </button>
                            </div>

                            <div class="terms-full-scroll">
                                <div class="terms-full-text">
                                    <p><strong>Términos y Condiciones Promoción: Con tu primer depósito obtén 10 Free
                                            Spin gratis.</strong></p>

                                    <p>
                                        Tarplay ofrece a sus clientes la posibilidad de recibir 10 Free Spin gratis
                                        dentro de una
                                        selección de juegos de slots disponibles en la plataforma luego de su primer
                                        depósito.
                                    </p>

                                    <p>
                                        La participación en esta promoción implica la aceptación de los siguientes
                                        términos y condiciones.
                                    </p>

                                    <p><strong>1. Elegibilidad</strong></p>
                                    <p>
                                        Esta promoción estará disponible para todos los clientes que depositen por
                                        primera vez.
                                    </p>
                                    <p>
                                        El monto mínimo para participar es de 5 unidades.
                                    </p>
                                    <p>
                                        Cada cliente podrá participar una sola vez al realizar su primer depósito.
                                    </p>

                                    <p><strong>2. Activación</strong></p>
                                    <p>
                                        Luego del depósito, el cliente debe iniciar sesión y notificar la recarga para
                                        activar los
                                        10 Free Spins.
                                    </p>
                                    <p>
                                        El premio será acreditado como BONO CASINO con un máximo de 20 unidades.
                                    </p>

                                    <p><strong>3. Acreditación</strong></p>
                                    <p>
                                        Las ganancias no serán retirables inmediatamente y quedarán como saldo
                                        promocional.
                                    </p>

                                    <p><strong>4. Rollover</strong></p>
                                    <p>
                                        Para liberar el bono se debe cumplir un rollover de 5x utilizando dinero real.
                                    </p>
                                    <p>
                                        Ejemplo: si ganas $20, debes apostar $100 para liberar.
                                    </p>
                                    <p>
                                        Las ganancias del bono no se ven afectadas por el dinero real usado.
                                    </p>

                                    <ul>
                                        <li>Solo cuentan apuestas en slots.</li>
                                        <li>Otros juegos no aplican.</li>
                                        <li>El rollover se realiza con dinero real.</li>
                                    </ul>

                                    <p><strong>5. Liberación</strong></p>
                                    <p>
                                        Al completar el rollover, el saldo pasa a dinero real y puede retirarse.
                                    </p>

                                    <p><strong>6. Vigencia</strong></p>
                                    <p>
                                        El rollover debe completarse el mismo día o el bono se pierde.
                                    </p>

                                    <p><strong>7. Restricciones</strong></p>
                                    <ul>
                                        <li>Promoción personal e intransferible.</li>
                                        <li>Solo una vez por usuario.</li>
                                        <li>Los depósitos ayudan a completar el rollover.</li>
                                    </ul>

                                    <p><strong>8. Fraude</strong></p>
                                    <p>
                                        Tarplay puede cancelar bonos por abuso o fraude.
                                    </p>

                                    <p><strong>9. Cambios</strong></p>
                                    <p>
                                        Tarplay puede modificar o cancelar la promoción en cualquier momento.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- aceptación siempre visible -->
                        <div class="terms-accept-sticky">
                            <div class="terms-accept-box">
                                <label class="terms-check">
                                    <input v-model="termsChecked" type="checkbox" />
                                    <span>He leído y acepto los términos y condiciones de la promoción.</span>
                                </label>
                            </div>

                            <div class="terms-actions">
                                <button class="terms-primary-btn" :disabled="!termsChecked"
                                    :class="{ 'terms-primary-btn--enabled': termsChecked }" @click="acceptTerms"
                                    type="button">
                                    Aceptar y continuar
                                </button>
                            </div>
                        </div>
                    </template>

                    <!-- VISTA NORMAL -->
                    <template v-else>
                        <div class="panel-header">
                            <div>
                                <div class="panel-eyebrow">PROMOCIÓN ACTIVA</div>
                                <div class="panel-title">Control de rollover</div>
                            </div>

                            <button class="panel-close" @click="open = false" type="button">✕</button>
                        </div>

                        <div class="panel-hero">
                            <div class="hero-left">
                                <div class="hero-label">Bono generado</div>
                                <div class="hero-amount">
                                    <span class="money-symbol money-symbol--hero">{{ moneda }}</span>
                                    <span>{{ numberOnly(montoBono) }}</span>
                                </div>
                            </div>

                            <div class="hero-right">
                                <div class="hero-chip">{{ rollover }}x rollover</div>
                            </div>
                        </div>

                        <div class="panel-actions-top">
                            <button class="terms-link-btn" @click="showTerms = true" type="button">
                                Ver términos y condiciones
                            </button>
                        </div>

                        <div class="panel-tabs">
                            <button type="button" class="panel-tab" :class="{ active: activeTab === 'summary' }"
                                @click="activeTab = 'summary'">
                                Resumen
                            </button>

                            <button type="button" class="panel-tab" :class="{ active: activeTab === 'history' }"
                                @click="activeTab = 'history'">
                                Historial
                                <span class="panel-tab__count">{{ transaccionesFiltradas.length }}</span>
                            </button>
                        </div>

                        <div v-if="activeTab === 'summary'">
                            <div class="progress-card">
                                <div class="progress-head">
                                    <span>Progreso acumulado</span>
                                    <strong>{{ progressPercent }}%</strong>
                                </div>

                                <div class="progress-bar">
                                    <div class="progress-bar__fill" :style="{ width: progressPercent + '%' }">
                                        <div class="progress-bar__shine"></div>
                                    </div>
                                </div>

                                <div class="progress-meta">
                                    <span>{{ formatMoney(apostado) }} jugado</span>
                                    <span>{{ formatMoney(metaTotal) }} meta</span>
                                </div>
                            </div>

                            <div class="stats-grid">
                                <div class="stat-card">
                                    <div class="stat-label">Bono</div>
                                    <div class="stat-value">
                                        <span class="money-symbol">{{ moneda }}</span>
                                        <span>{{ numberOnly(montoBono) }}</span>
                                    </div>
                                </div>

                                <div class="stat-card">
                                    <div class="stat-label">Meta total</div>
                                    <div class="stat-value">
                                        <span class="money-symbol">{{ moneda }}</span>
                                        <span>{{ numberOnly(metaTotal) }}</span>
                                    </div>
                                </div>

                                <div class="stat-card">
                                    <div class="stat-label">Llevas jugado</div>
                                    <div class="stat-value">
                                        <span class="money-symbol">{{ moneda }}</span>
                                        <span>{{ numberOnly(apostado) }}</span>
                                    </div>
                                </div>

                                <div class="stat-card">
                                    <div class="stat-label">Te falta</div>
                                    <div class="stat-value">
                                        <span class="money-symbol">{{ moneda }}</span>
                                        <span>{{ numberOnly(faltante) }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="status-box" :class="cumplido ? 'status-box--complete' : 'status-box--pending'">
                                <div class="status-icon">
                                    {{ cumplido ? '✅' : '⏳' }}
                                </div>

                                <div class="status-text">
                                    <div class="status-title">
                                        {{ cumplido ? 'Rollover completado' : 'Rollover en progreso' }}
                                    </div>

                                    <div class="status-subtitle">
                                        {{
                                            cumplido
                                                ? 'Ya puedes convertir tu bono a saldo real.'
                                                : `Te faltan ${formatMoney(faltante)} para llegar a la meta.`
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else class="history-card">
                            <div class="history-head">
                                <span>Movimientos del bono</span>
                                <strong>{{ transaccionesFiltradas.length }}</strong>
                            </div>

                            <div v-if="transaccionesFiltradas.length" class="history-list">
                                <div v-for="tx in transaccionesFiltradas" :key="tx.codigo || tx.ref"
                                    class="history-item">
                                    <div class="history-left">
                                        <div class="history-type">
                                            {{ normalizeType(tx.tipo) }}
                                        </div>
                                        <div class="history-date">
                                            {{ tx.fecha }} {{ tx.hora }}
                                        </div>
                                    </div>

                                    <div class="history-right">
                                        <div class="history-amount" :class="isBet(tx.tipo) ? 'is-bet' : 'is-win'">
                                            <span class="money-symbol money-symbol--tx">{{ moneda }}</span>
                                            <span>{{ signedAmount(tx) }}</span>
                                        </div>

                                        <div class="history-balance">
                                            Saldo:
                                            <span class="money-symbol money-symbol--tx">{{ moneda }}</span>
                                            <span>{{ numberOnly(tx.balance) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="history-empty">
                                Aún no hay movimientos relevantes para mostrar.
                            </div>
                        </div>

                        <button class="redeem-btn" :class="{ 'redeem-btn--enabled': cumplido }"
                            :disabled="!cumplido || loading" @click="handleRedeem" type="button">
                            <span v-if="loading">Canjeando...</span>
                            <span v-else>Canjear</span>
                        </button>
                    </template>
                </div>
            </transition>

            <!-- RESUMEN FLOTANTE -->
            <button ref="fab" class="rollover-fab" :class="{ 'rollover-fab--disabled': showTerms && !termsAccepted }"
                @click="handleFabClick" @mousedown="startDrag" @touchstart.passive="startDrag" type="button">
                <div class="fab-glow"></div>

                <div class="fab-icon">
                    <span>🎁</span>
                </div>

                <div class="fab-content">
                    <div class="fab-top">
                        <span class="fab-badge" :class="cumplido ? 'is-complete' : 'is-live'">
                            {{ cumplido ? 'LISTO' : 'BONO ACTIVO' }}
                        </span>
                    </div>

                    <div class="fab-title">Rollover promocional</div>

                    <div class="fab-subtitle">
                        {{ formatMoney(apostado) }} / {{ formatMoney(metaTotal) }}
                    </div>
                </div>

                <div class="fab-progress-ring">
                    <svg viewBox="0 0 36 36" class="circular-chart">
                        <path class="circle-bg" d="M18 2.0845
               a 15.9155 15.9155 0 0 1 0 31.831
               a 15.9155 15.9155 0 0 1 0 -31.831" />
                        <path class="circle" :stroke-dasharray="`${progressPercent}, 100`" d="M18 2.0845
               a 15.9155 15.9155 0 0 1 0 31.831
               a 15.9155 15.9155 0 0 1 0 -31.831" />
                    </svg>
                    <div class="ring-text">{{ progressPercent }}%</div>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "RolloverTrackerReal",

    props: {
        visible: { type: Boolean, default: true },
        montoBono: { type: Number, required: true },
        rollover: { type: Number, default: 5 },
        apostado: { type: Number, default: 0 },
        moneda: { type: String, default: "$" },
        loading: { type: Boolean, default: false },
        autoOpenOnComplete: { type: Boolean, default: true },
        startOpen: { type: Boolean, default: false },
        transacciones: { type: Array, default: () => [] },
        termsStorageKey: { type: String, default: "rollover_terms_accepted" },
        useSessionStorage: { type: Boolean, default: true },
    },

    data() {
        return {
            open: this.startOpen,
            wasCompleted: false,
            activeTab: "summary",
            dragX: 0,
            dragY: 0,
            dragging: false,
            dragStartX: 0,
            dragStartY: 0,
            initialDragX: 0,
            initialDragY: 0,
            movedDuringDrag: false,
            panelVertical: "bottom",
            panelHorizontal: "left",
            showTerms: false,
            termsAccepted: false,
            showFullTerms: false,
            termsChecked: false,
        };
    },

    computed: {
        metaTotal() {
            return Number(this.montoBono || 0) * Number(this.rollover || 0);
        },

        faltante() {
            return Math.max(this.metaTotal - Number(this.apostado || 0), 0);
        },

        cumplido() {
            return this.metaTotal > 0 && Number(this.apostado || 0) >= this.metaTotal;
        },

        progressPercent() {
            if (!this.metaTotal) return 0;
            const raw = (Number(this.apostado || 0) / this.metaTotal) * 100;
            return Math.min(Math.round(raw), 100);
        },

        transaccionesFiltradas() {
            return [...this.transacciones]
                .filter((tx) => {
                    const monto = Number(tx?.monto || 0);
                    const tipo = String(tx?.tipo || "").toLowerCase();

                    if (tipo.includes("win") && monto === 0) return false;
                    return true;
                })
                .sort((a, b) => Number(b.codigo || 0) - Number(a.codigo || 0));
        },

        wrapStyle() {
            return {
                transform: `translate(${this.dragX}px, ${this.dragY}px)`,
            };
        },

        panelPlacementClass() {
            return {
                "panel-bottom": this.panelVertical === "bottom",
                "panel-top": this.panelVertical === "top",
                "panel-left": this.panelHorizontal === "left",
                "panel-right": this.panelHorizontal === "right",
            };
        },

        storageApi() {
            return this.useSessionStorage ? window.sessionStorage : window.localStorage;
        },
    },

    watch: {
        visible(val) {
            if (val) {
                this.initTermsState();
            }
        },

        cumplido(newVal) {
            if (newVal && !this.wasCompleted) {
                this.wasCompleted = true;
                if (this.autoOpenOnComplete) this.open = true;
            }
        },

        open(val) {
            if (val) {
                this.$nextTick(() => {
                    this.updatePanelPlacement();
                });
            }
        },
    },

    mounted() {
        this.initTermsState();

        window.addEventListener("mousemove", this.onDragMove);
        window.addEventListener("mouseup", this.stopDrag);
        window.addEventListener("touchmove", this.onDragMove, { passive: false });
        window.addEventListener("touchend", this.stopDrag);
        window.addEventListener("resize", this.handleResize);
    },

    beforeDestroy() {
        window.removeEventListener("mousemove", this.onDragMove);
        window.removeEventListener("mouseup", this.stopDrag);
        window.removeEventListener("touchmove", this.onDragMove);
        window.removeEventListener("touchend", this.stopDrag);
        window.removeEventListener("resize", this.handleResize);
    },

    methods: {
        initTermsState() {
            try {
                this.termsAccepted = this.storageApi.getItem(this.termsStorageKey) === "1";
            } catch (e) {
                this.termsAccepted = false;
            }

            if (!this.termsAccepted) {
                this.open = true;
                this.showTerms = true;
                this.showFullTerms = false;
                this.termsChecked = false;
            } else {
                this.showTerms = false;
            }
        },

        acceptTerms() {
            if (!this.termsChecked) return;

            try {
                this.storageApi.setItem(this.termsStorageKey, "1");
            } catch (e) {
                console.warn("No se pudo guardar la aceptación de términos:", e);
            }

            this.termsAccepted = true;
            this.showTerms = false;
            this.showFullTerms = false;
            this.activeTab = "summary";

            this.$nextTick(() => this.updatePanelPlacement());
        },

        formatMoney(value) {
            const n = Number(value || 0);
            return `${this.moneda}${n.toFixed(2)}`;
        },

        numberOnly(value) {
            return Number(value || 0).toFixed(2);
        },

        isBet(tipo) {
            return String(tipo || "").toLowerCase().includes("bet");
        },

        normalizeType(tipo) {
            const t = String(tipo || "").toLowerCase();
            if (t.includes("bet")) return "Apuesta";
            if (t.includes("win")) return "Ganancia";
            if (t.includes("rollback")) return "Reverso";
            return tipo || "Movimiento";
        },

        signedAmount(tx) {
            const n = Number(tx?.monto || 0);
            const tipo = String(tx?.tipo || "").toLowerCase();
            if (tipo.includes("bet")) return n.toFixed(2);
            if (tipo.includes("win")) return `+${n.toFixed(2)}`;
            return n.toFixed(2);
        },

        handleRedeem() {
            if (!this.cumplido || this.loading) return;
            this.$emit("redeem");
        },

        handleFabClick() {
            if (this.movedDuringDrag) {
                this.movedDuringDrag = false;
                return;
            }

            if (!this.termsAccepted) {
                this.open = true;
                this.showTerms = true;
                return;
            }

            this.open = !this.open;
        },

        getPointerX(event) {
            if (event.touches && event.touches.length) return event.touches[0].clientX;
            return event.clientX;
        },

        getPointerY(event) {
            if (event.touches && event.touches.length) return event.touches[0].clientY;
            return event.clientY;
        },

        startDrag(event) {
            if (this.showTerms && !this.termsAccepted) return;

            this.dragging = true;
            this.movedDuringDrag = false;
            this.dragStartX = this.getPointerX(event);
            this.dragStartY = this.getPointerY(event);
            this.initialDragX = this.dragX;
            this.initialDragY = this.dragY;
        },

        onDragMove(event) {
            if (!this.dragging) return;
            if (event.cancelable) event.preventDefault();

            const currentX = this.getPointerX(event);
            const currentY = this.getPointerY(event);
            const deltaX = currentX - this.dragStartX;
            const deltaY = currentY - this.dragStartY;

            if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) {
                this.movedDuringDrag = true;
            }

            const wrapWidth = (this.$refs.wrap?.offsetWidth || 300);
            const fabHeight = (this.$refs.fab?.offsetHeight || 70);

            const minX = -10;
            const maxX = Math.max((window.innerWidth || 0) - wrapWidth - 10, 0);

            const minY = -10;
            const maxY = Math.max((window.innerHeight || 0) - fabHeight - 10, 0);

            this.dragX = Math.min(Math.max(this.initialDragX + deltaX, minX), maxX);
            this.dragY = Math.min(Math.max(this.initialDragY + deltaY, minY), maxY);

            if (this.open) {
                this.updatePanelPlacement();
            }
        },

        stopDrag() {
            this.dragging = false;
        },

        handleResize() {
            if (this.open) {
                this.$nextTick(() => this.updatePanelPlacement());
            }
        },

        updatePanelPlacement() {
            this.$nextTick(() => {
                const fab = this.$refs.fab;
                const panel = this.$refs.panel;
                if (!fab || !panel) return;

                const fabRect = fab.getBoundingClientRect();
                const panelRect = panel.getBoundingClientRect();

                const spaceBelow = window.innerHeight - fabRect.bottom;
                const spaceAbove = fabRect.top;
                const neededVertical = panelRect.height + 10;

                this.panelVertical = spaceBelow >= neededVertical || spaceBelow >= spaceAbove
                    ? "bottom"
                    : "top";

                const spaceRight = window.innerWidth - fabRect.left;
                const spaceLeft = fabRect.right;
                const neededHorizontal = panelRect.width;

                this.panelHorizontal = spaceRight >= neededHorizontal || spaceRight >= spaceLeft
                    ? "left"
                    : "right";
            });
        },
    },
};
</script>

<style scoped>
.terms-overlay-blocker {
    position: fixed;
    inset: 0;
    z-index: 1299;
    background: rgba(15, 23, 42, 0.55);
    backdrop-filter: blur(3px);
}

.rollover-wrap {
    position: fixed;
    left: 12px;
    top: 12px;
    z-index: 1300;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    transition: transform 0.08s linear;
    will-change: transform;
}

.rollover-fab {
    position: relative;
    width: 300px;
    max-width: calc(100vw - 24px);
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px;
    border: 0;
    border-radius: 18px;
    cursor: pointer;
    overflow: hidden;
    text-align: left;
    background:
        radial-gradient(circle at top right, rgba(250, 204, 21, 0.22), transparent 32%),
        linear-gradient(135deg, #0f172a 0%, #172554 48%, #1d4ed8 100%);
    color: #fff;
    box-shadow:
        0 12px 28px rgba(15, 23, 42, 0.28),
        inset 0 1px 0 rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(12px);
    user-select: none;
}

.rollover-fab--disabled {
    opacity: 0.96;
}

.fab-glow {
    position: absolute;
    inset: auto -40px -40px auto;
    width: 120px;
    height: 120px;
    background: radial-gradient(circle, rgba(250, 204, 21, 0.35), transparent 65%);
    pointer-events: none;
}

.fab-icon {
    width: 42px;
    height: 42px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.10);
    font-size: 20px;
    flex: 0 0 auto;
}

.fab-content {
    flex: 1;
    min-width: 0;
}

.fab-top {
    margin-bottom: 4px;
}

.fab-badge {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 3px 8px;
    font-size: 9px;
    font-weight: 900;
    letter-spacing: .7px;
    text-transform: uppercase;
}

.fab-badge.is-live {
    background: rgba(255, 255, 255, 0.14);
    color: #e2e8f0;
}

.fab-badge.is-complete {
    background: rgba(34, 197, 94, 0.18);
    color: #bbf7d0;
}

.fab-title {
    font-size: 13px;
    font-weight: 800;
    line-height: 1.1;
}

.fab-subtitle {
    margin-top: 3px;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.85);
}

.fab-progress-ring {
    position: relative;
    width: 46px;
    height: 46px;
    flex: 0 0 auto;
}

.circular-chart {
    width: 46px;
    height: 46px;
    transform: rotate(-90deg);
}

.circle-bg {
    fill: none;
    stroke: rgba(255, 255, 255, 0.14);
    stroke-width: 3.2;
}

.circle {
    fill: none;
    stroke: #facc15;
    stroke-width: 3.2;
    stroke-linecap: round;
    transition: stroke-dasharray .4s ease;
}

.ring-text {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 900;
    color: #fff;
}

.rollover-panel {
    position: absolute;
    width: 340px;
    max-width: calc(100vw - 24px);
    border-radius: 22px;
    overflow: hidden;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid #e5e7eb;
    box-shadow:
        0 20px 45px rgba(15, 23, 42, 0.18),
        0 8px 20px rgba(15, 23, 42, 0.06);
}

.panel-bottom {
    top: calc(100% + 8px);
}

.panel-top {
    bottom: calc(100% + 8px);
}

.panel-left {
    left: 0;
}

.panel-right {
    right: 0;
}

.panel-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 16px 16px 10px;
    border-bottom: 1px solid #eef2f7;
}

.panel-eyebrow {
    font-size: 10px;
    font-weight: 900;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: .8px;
}

.panel-title {
    margin-top: 2px;
    font-size: 18px;
    font-weight: 900;
    color: #0f172a;
    line-height: 1.1;
}

.panel-close {
    border: 0;
    background: #f1f5f9;
    color: #475569;
    width: 30px;
    height: 30px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 800;
}

.panel-hero {
    margin: 14px 16px 0;
    padding: 14px;
    border-radius: 16px;
    background:
        radial-gradient(circle at top right, rgba(250, 204, 21, 0.22), transparent 35%),
        linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
}

.terms-compact-hero {
    margin: 14px 16px 0;
    padding: 12px 14px;
    border-radius: 14px;
    background:
        radial-gradient(circle at top right, rgba(250, 204, 21, 0.18), transparent 35%),
        linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.terms-compact-left {
    min-width: 0;
}

.terms-mini-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.12);
    font-size: 10px;
    font-weight: 800;
    margin-bottom: 6px;
}

.terms-mini-title {
    display: flex;
    align-items: flex-start;
    gap: 2px;
    flex-wrap: wrap;
    font-size: 20px;
    font-weight: 900;
    color: #facc15;
    text-shadow:
        0 2px 6px rgba(0, 0, 0, 0.45),
        0 1px 1px rgba(0, 0, 0, 0.7);
}

.terms-mini-title__extra {
    font-size: 14px;
    color: #fff;
    font-weight: 800;
    margin-left: 4px;
}

.terms-mini-chip,
.hero-chip {
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.12);
    padding: 7px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 800;
    white-space: nowrap;
}

.hero-label {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.78);
}

.hero-amount {
    margin-top: 4px;
    font-size: 24px;
    font-weight: 900;
    color: #facc15;
    text-shadow:
        0 2px 6px rgba(0, 0, 0, 0.45),
        0 1px 1px rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: flex-start;
    gap: 2px;
}

.panel-actions-top {
    margin: 12px 16px 0;
}

.terms-link-btn {
    border: 0;
    background: transparent;
    color: #1d4ed8;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    padding: 0;
}

.panel-tabs {
    margin: 12px 16px 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.panel-tab {
    border: 1px solid #dbe4ef;
    background: #fff;
    color: #334155;
    padding: 9px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.panel-tab.active {
    background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%);
    color: #fff;
    border-color: transparent;
}

.panel-tab__count {
    font-size: 10px;
    opacity: .9;
}

.progress-card,
.history-card,
.terms-summary-card,
.terms-full-card {
    margin: 12px 16px 0;
    padding: 14px;
    border-radius: 16px;
    background: #fff;
    border: 1px solid #edf2f7;
}

.progress-head,
.history-head,
.terms-full-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
    font-size: 13px;
    color: #334155;
}

.progress-head strong,
.history-head strong {
    color: #0f172a;
}

.progress-bar {
    width: 100%;
    height: 12px;
    border-radius: 999px;
    overflow: hidden;
    background: #e5e7eb;
    position: relative;
}

.progress-bar__fill {
    height: 100%;
    border-radius: 999px;
    position: relative;
    overflow: hidden;
    background: linear-gradient(90deg, #22c55e 0%, #16a34a 45%, #facc15 100%);
    transition: width .35s ease;
}

.progress-bar__shine {
    position: absolute;
    inset: 0;
    background: linear-gradient(120deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.35) 45%,
            rgba(255, 255, 255, 0) 90%);
    transform: translateX(-100%);
    animation: shine 2.4s infinite linear;
}

.progress-meta {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    font-size: 11px;
    color: #64748b;
}

.stats-grid {
    margin: 12px 16px 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
}

.stat-card {
    background: #fff;
    border: 1px solid #edf2f7;
    border-radius: 14px;
    padding: 12px;
}

.stat-label {
    font-size: 11px;
    color: #64748b;
}

.stat-value {
    margin-top: 5px;
    font-size: 16px;
    font-weight: 900;
    color: #0f172a;
    display: flex;
    align-items: flex-start;
    gap: 2px;
}

.money-symbol {
    font-size: 10px;
    line-height: 1.2;
    opacity: 0.85;
    margin-top: 2px;
}

.money-symbol--hero {
    font-size: 13px;
    margin-top: 4px;
}

.money-symbol--tx {
    font-size: 10px;
    margin-top: 2px;
}

.status-box {
    margin: 12px 16px 0;
    border-radius: 16px;
    padding: 12px;
    display: flex;
    gap: 10px;
    align-items: flex-start;
}

.status-box--pending {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
}

.status-box--complete {
    background: #ecfdf5;
    border: 1px solid #86efac;
}

.status-icon {
    font-size: 17px;
    line-height: 1;
    margin-top: 1px;
}

.status-title {
    font-size: 13px;
    font-weight: 900;
    color: #0f172a;
}

.status-subtitle {
    margin-top: 3px;
    font-size: 11px;
    color: #475569;
    line-height: 1.35;
}

.history-list {
    max-height: 240px;
    overflow-y: auto;
    display: grid;
    gap: 8px;
    padding-right: 2px;
}

.history-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 0;
    border-top: 1px solid #f1f5f9;
}

.history-item:first-child {
    border-top: 0;
    padding-top: 0;
}

.history-left {
    min-width: 0;
    flex: 1;
}

.history-type {
    font-size: 12px;
    font-weight: 800;
    color: #0f172a;
}

.history-date {
    margin-top: 3px;
    font-size: 10px;
    color: #64748b;
}

.history-right {
    text-align: right;
    flex: 0 0 auto;
}

.history-amount {
    font-size: 13px;
    font-weight: 900;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 2px;
}

.history-amount.is-bet {
    color: #dc2626;
}

.history-amount.is-win {
    color: #16a34a;
}

.history-balance {
    margin-top: 3px;
    font-size: 10px;
    color: #64748b;
}

.history-empty {
    padding: 18px 8px 6px;
    text-align: center;
    font-size: 12px;
    color: #64748b;
}

.terms-summary-title {
    font-size: 13px;
    font-weight: 900;
    color: #0f172a;
    margin-bottom: 10px;
}

.terms-summary-list {
    display: grid;
    gap: 8px;
}

.terms-summary-item {
    font-size: 12px;
    line-height: 1.45;
    color: #334155;
}

.terms-toggle-btn {
    border: 0;
    background: transparent;
    color: #1d4ed8;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    padding: 0;
    margin-top: 12px;
}

.terms-toggle-btn--back {
    margin-top: 0;
}

.terms-full-scroll {
    max-height: 220px;
    overflow-y: auto;
    padding-right: 4px;
}

.terms-full-text {
    font-size: 12px;
    line-height: 1.55;
    color: #334155;
}

.terms-full-text p {
    margin: 0 0 10px 0;
}

.terms-full-text ul {
    margin: 0 0 10px 18px;
    padding: 0;
}

.terms-full-text li {
    margin-bottom: 6px;
}

.terms-accept-sticky {
    position: sticky;
    bottom: 0;
    background: linear-gradient(180deg, rgba(248, 250, 252, 0.88) 0%, #f8fafc 22%, #f8fafc 100%);
    backdrop-filter: blur(6px);
    padding-top: 10px;
}

.terms-accept-box {
    margin: 0 16px;
    padding: 12px 14px;
    border-radius: 14px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
}

.terms-check {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 12px;
    line-height: 1.45;
    color: #334155;
    cursor: pointer;
}

.terms-check input {
    margin-top: 2px;
    flex: 0 0 auto;
}

.terms-actions {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin: 12px 16px 16px;
}

.terms-primary-btn,
.redeem-btn {
    border: 0;
    border-radius: 14px;
    padding: 12px;
    font-size: 14px;
    font-weight: 900;
    transition: all .25s ease;
}

.terms-primary-btn {
    color: #fff;
    background: #cbd5e1;
    cursor: not-allowed;
}

.terms-primary-btn--enabled {
    background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 65%, #2563eb 100%);
    cursor: pointer;
    box-shadow:
        0 14px 28px rgba(30, 64, 175, 0.28),
        inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.redeem-btn {
    width: calc(100% - 32px);
    margin: 14px 16px 16px;
    color: #fff;
    background: #cbd5e1;
    cursor: not-allowed;
}

.redeem-btn--enabled {
    background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 65%, #2563eb 100%);
    box-shadow:
        0 14px 28px rgba(30, 64, 175, 0.28),
        inset 0 1px 0 rgba(255, 255, 255, 0.12);
    cursor: pointer;
}

.redeem-btn--enabled:hover,
.terms-primary-btn--enabled:hover {
    transform: translateY(-1px);
}

.tracker-pop-enter-active,
.tracker-pop-leave-active {
    transition: all .28s ease;
}

.tracker-pop-enter,
.tracker-pop-leave-to {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
}

@keyframes shine {
    to {
        transform: translateX(100%);
    }
}
</style>